import * as React from 'react';
import { send_authorized_request } from '../../Constants/cognito'
import { AXIOS_API_INSTANCE } from '../../Constants';
import { useSnackbar } from 'notistack';
import { Box, Button, Divider, IconButton, InputAdornment, MenuItem, Select, Slider, Tab, Tabs, TextField, Tooltip } from '@mui/material';
import Grid from "@mui/material/Grid2"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import { rate_calculation, rate_chunks, rate_visualization } from '../../Utils';
import axios from 'axios';
import { LoadingBackdropIndeterminate } from '../LoadingBackdrop';
import ConfirmModal from '../modals/ConfirmModal';

export default function RateGroupPage({ rateGroup, creatingNewRateGroup, closeFunction }) {
    const { enqueueSnackbar } = useSnackbar();
    const [myRentalRateGroup, setMyRentalRateGroup] = React.useState(rateGroup)
    const [tab, setTab] = React.useState(1)
    const [showThresholds, setShowThresholds] = React.useState(rateGroup.rental_rates.length > 1)
    const [maxRatesShown, setMaxRatesShown] = React.useState(20)
    const [isLoading, setIsLoading] = React.useState(false)
    const [deleteThresholdConfirmation, setDeleteThresholdConfirmation] = React.useState({
        open: false,
        text: '',
        callback: null
    })
    const [addThresholdModal, setAddThresholdModal] = React.useState({
        open: false,
        existing_thresholds: [],
        callback: null
    })
    const currently_selected_rate_group = myRentalRateGroup.rental_rates.find((x) => x.quantity === parseInt(tab))
    console.log(currently_selected_rate_group)


    const handleChange = (prop) => (event) => {
        console.log(myRentalRateGroup)
        setMyRentalRateGroup({ ...myRentalRateGroup, [prop]: event.target.value })
    }
    const handleRateChange = (prop, id) => (event) => {
        console.log(event)
        console.log(event.target.value)
        const newRentalRates = currently_selected_rate_group.rental_rates
        if ('time_range' === prop) {
            newRentalRates[id]['min_time'] = parseInt(event.target.value[0])
            newRentalRates[id]['max_time'] = parseInt(event.target.value[1])
        } else if ('rate' === prop) {
            newRentalRates[id][prop] = parseInt(event.target.value)
        } else {
            newRentalRates[id][prop] = event.target.value
        }
        setMyRentalRateGroup({ ...myRentalRateGroup })
    }
    const generate_marks = (start, end, text) => {
        return [...Array(end + 1 - start).keys()].map((value) => {
            const index = value + start
            if (index === 1 || index === end) {
                return {
                    value: index,
                    label: `${index} ${text}`
                }
            } else {
                return {
                    value: index,
                    label: ''
                }
            }
        })
    }
    const createQuantityThreshold = () => {
        setAddThresholdModal({
            open: true,
            existing_thresholds: myRentalRateGroup.rental_rates.map((x) => x.quantity),
            callback: (quantity) => {
                if (quantity > 1) {
                    const index = myRentalRateGroup.rental_rates.findIndex((group) => group.quantity > quantity)
                    if (index === -1) {
                        myRentalRateGroup.rental_rates.push({ quantity: quantity, rental_rates: structuredClone(myRentalRateGroup.rental_rates.at(-1).rental_rates) })
                    } else {
                        myRentalRateGroup.rental_rates.splice(index, 0, { quantity: quantity, rental_rates: structuredClone(myRentalRateGroup.rental_rates[index - 1].rental_rates) })
                    }
                    setMyRentalRateGroup({ ...myRentalRateGroup })
                    setTab(quantity)
                }
                setAddThresholdModal({ ...addThresholdModal, open: false })
            }
        })
    }
    const deleteQuantityThreshold = (event, index) => {
        event.stopPropagation();
        const text = `Are you sure you want to delete threshold ${myRentalRateGroup.rental_rates[index].quantity}?`
        setDeleteThresholdConfirmation({
            open: true,
            text: text,
            callback: (confirmation) => {
                if (confirmation) {
                    myRentalRateGroup.rental_rates.splice(index, 1)
                    setTab(myRentalRateGroup.rental_rates[index - 1].quantity)
                    setMyRentalRateGroup({ ...myRentalRateGroup })
                }
                setDeleteThresholdConfirmation({ text: text, open: false })
            }
        })
    }
    const createNewRate = (index) => {
        if (index === 0) {
            const new_rate = Object.assign({}, currently_selected_rate_group.rental_rates[0] ?? { max_time: 1, min_time: 1, time_unit: 'h', name: 'New Rate', rate: 1 });
            new_rate.max_time = new_rate.min_time
            new_rate.name = 'New Rate'
            currently_selected_rate_group.rental_rates.splice(index, 0, new_rate)
        } else {
            const new_rate = Object.assign({}, currently_selected_rate_group.rental_rates[index - 1]);
            new_rate.min_time = new_rate.max_time
            new_rate.name = 'New Rate'
            currently_selected_rate_group.rental_rates.splice(index, 0, new_rate)
        }
        setMyRentalRateGroup({ ...myRentalRateGroup })
    }
    const removeRate = (index) => {
        currently_selected_rate_group.rental_rates.splice(index, 1)
        setMyRentalRateGroup({ ...myRentalRateGroup })
    }

    const save = () => {
        setIsLoading(true)
        console.log(myRentalRateGroup)
        console.log("new rateGroup " + creatingNewRateGroup)
        delete myRentalRateGroup.date_created
        delete myRentalRateGroup.date_updated
        if (creatingNewRateGroup) {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.put(`rentalrategroups`, myRentalRateGroup).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully created rate group', { variant: 'success' })
                        setIsLoading(false)
                        closeFunction(true)
                    })
                ).catch((error) => {
                    setIsLoading(false)
                    enqueueSnackbar(`Failed to create rate group <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        } else {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(
                    `rentalrategroups/${myRentalRateGroup.id}`,
                    myRentalRateGroup
                ).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully updated rate group', { variant: 'success' })
                        setIsLoading(false)
                    })
                ).catch((error) => {
                    setIsLoading(false)
                    enqueueSnackbar(`Failed to update rate group <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        }
    }
    const delete_rental_rate_group = () => {
        console.log('delete rate group')
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.delete(`rentalrategroups/${myRentalRateGroup.id}`).then(
                axios.spread(() => {
                    enqueueSnackbar('Successfully deleted rate group', { variant: 'success' })
                    closeFunction(true)
                })
            )
        )
    }
    // Calculate charges:
    const my_calculated_charges = myRentalRateGroup.rental_rates.map((rates) => {
        const results = rate_calculation(rates.rental_rates)
        const chunks = rate_chunks(results[0])
        return { quantity: rates.quantity, rates: rate_visualization(chunks, maxRatesShown), found_issue_with_rates: results[1], rate_num: chunks.length }
    })

    const rates_in_a_column = currently_selected_rate_group.rental_rates.map((rate, index) => {
        return (
            (<Grid key={index} size="grow">
                <Box sx={{ border: '1px solid grey', padding: '15px 30px 15px 30px' }}>
                    <Grid container justifyContent={"space-between"}>
                        <Grid size="grow">
                            <span><b>Rate{" "}{index + 1}</b></span>
                        </Grid>
                        <Grid size="auto">
                            <IconButton onClick={() => removeRate(index)}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <TextField
                        margin="dense"
                        id="name"
                        label="Rate Name"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={
                            rate.name || ""
                        }
                        onChange={handleRateChange("name", index)}
                    />
                    <Grid container spacing={1}>
                        <Grid size={8}>
                            <TextField
                                margin="dense"
                                id="rate"
                                label="Rate"
                                type="number"
                                fullWidth
                                variant="standard"
                                value={
                                    rate.rate || ""
                                }
                                onChange={handleRateChange("rate", index)}
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start" ><AttachMoneyIcon /></InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">{rate.time_unit === 'h' ? '/ hour' : '/ day'}</InputAdornment>
                                        )
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Select
                                fullWidth
                                margin="dense"
                                id="time_unit"
                                label="Rate Time Unit"
                                select
                                value={
                                    rate.time_unit || ""
                                }
                                onChange={handleRateChange("time_unit", index)}
                            >
                                <MenuItem value="h">Hourly</MenuItem>
                                <MenuItem value="d">Daily</MenuItem>
                            </Select>
                        </Grid>
                    </Grid>
                    <Box sx={{ pt: 5 }}>
                        <Slider
                            getAriaLabel={() => 'Time Range'}
                            value={[rate.min_time, rate.max_time]}
                            onChange={handleRateChange("time_range", index)}
                            valueLabelDisplay="on"
                            getAriaValueText={(value) => `${value}${rate.time_unit}`}
                            marks={generate_marks(1, Math.max(24, (parseInt(rate.max_time) || 0) + 1), rate.time_unit === 'h' ? 'hours' : 'days')}
                            step={1}
                            min={1}
                            max={Math.max(24, (parseInt(rate.max_time) || 0) + 2)}
                        />
                    </Box>
                </Box>
            </Grid>)
        );
    })
    const rate_add_buttons = Array.apply(null, Array(currently_selected_rate_group.rental_rates.length + 1)).map((x, index) => {
        return (
            (<Grid key={"add" + index.toString()} alignItems="center" size="grow">
                <Box textAlign={"center"}>
                    <Button onClick={() => createNewRate(index)} color="primary"><AddCircleSharpIcon /><Box sx={{ pl: 1 }}>Add Rate</Box></Button>
                </Box>
            </Grid>)
        );
    })
    const rates_column = rate_add_buttons.map((element, index) => [element, rates_in_a_column[index]]).flat();


    return (
        (<React.Fragment>
            <LoadingBackdropIndeterminate
                open={isLoading}
                text={"Saving Rate Group"}
            />
            <Box sx={{ pl: 1, pr: 1 }}>
                <Grid container space={1} alignItems="center" justifyContent={"flex-end"}>
                    <Grid size="grow">
                        <h2>{creatingNewRateGroup ? "CREATING NEW RATE GROUP" : "EDITING RATE GROUP"}</h2>
                    </Grid>
                    <Grid size="auto">
                        <IconButton onClick={() => closeFunction(true)}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid container spacing={3} justifyContent={"flex-end"}>
                    <Grid size="grow">
                        <Grid spacing={1} container direction="column">
                            <Grid size="grow">
                                <TextField
                                    margin="dense"
                                    id="name"
                                    label="Rate Group Name"
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    value={myRentalRateGroup.name || ""}
                                    onChange={handleChange("name")}
                                />
                            </Grid>
                            <Grid size="grow">
                                {showThresholds &&
                                    <Grid container spacing={3} alignItems='center'>
                                        <Grid size="grow">
                                            <Tabs
                                                value={tab}
                                                onChange={(e, value) => setTab(value)}
                                                variant="fullWidth"
                                                slotProps={{
                                                    indicator: { sx: { backgroundColor: '#009be5' } }
                                                }}
                                            >
                                                {myRentalRateGroup.rental_rates.map((group, index) =>
                                                    <Tab
                                                        label={`${group.quantity}+`}
                                                        value={group.quantity}
                                                        sx={{ fontWeight: "bold" }}
                                                        icon={group.quantity !== 1 ? <CloseIcon onClick={(event) => deleteQuantityThreshold(event, index)} /> : null}
                                                        iconPosition="end"
                                                    />
                                                )
                                                }
                                            </Tabs >
                                        </Grid>
                                        <Grid size='auto'>
                                            <Button onClick={createQuantityThreshold} variant="contained" color="primary"><AddCircleSharpIcon /><Box sx={{ pl: 1 }}>Add Threshold</Box></Button>
                                        </Grid>
                                    </Grid>
                                }{!showThresholds &&
                                    <Grid container spacing={3} alignItems='center'>
                                        <Grid size="grow">
                                            <Divider variant="middle" />
                                        </Grid>
                                        <Grid size='auto'>
                                            <Button onClick={() => setShowThresholds(true)} color="primary">Show Thresholds</Button>
                                        </Grid>
                                        <Grid size="grow">
                                            <Divider variant="middle" />
                                        </Grid>
                                    </Grid>

                                }
                            </Grid>
                        </Grid>
                        {rates_column}
                    </Grid>
                    <Grid size="grow">
                        <Grid spacing={1} container direction="column">
                            <Grid spacing={1} container>
                                {my_calculated_charges.map((calculated_charges) => {
                                    return (
                                        <Grid size="grow">
                                            <Grid spacing={1} container direction="column">
                                                {my_calculated_charges.length > 1 &&
                                                    <Grid size="grow">
                                                        <span><b>{calculated_charges.quantity}+</b></span>
                                                    </Grid>
                                                }

                                                {calculated_charges.found_issue_with_rates &&
                                                    <Grid size="grow">
                                                        ERROR WITH RATE LOGIC
                                                    </Grid>
                                                }
                                                {!calculated_charges.found_issue_with_rates &&
                                                    <Grid size="grow">
                                                        {calculated_charges.rates}
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                    );
                                })}

                                {my_calculated_charges.some((x) => { return !x.found_issue_with_rates && x.rate_num > maxRatesShown }) &&
                                    <Grid container spacing={3} alignItems='center'>
                                        <Grid size="grow">
                                            <Divider variant="middle" />
                                        </Grid>
                                        <Grid size='auto'>
                                            <Button onClick={() => setMaxRatesShown(maxRatesShown + 10)} color="primary">See More Rates</Button>
                                        </Grid>
                                        <Grid size="grow">
                                            <Divider variant="middle" />
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                            <Grid size="grow">
                                <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                                    <Grid size="auto">
                                        {!creatingNewRateGroup &&
                                            <Tooltip title={myRentalRateGroup.deletable_reason}>
                                                <span> {/* span required for tooltip events */}
                                                    <Button disabled={!myRentalRateGroup.deletable} variant='outlined' color='error' onClick={delete_rental_rate_group} sx={{ mr: 1 }}>
                                                        <DeleteIcon /> <Box sx={{ pl: 1 }}><span>Delete</span></Box>
                                                    </Button>
                                                </span>
                                            </Tooltip>
                                        }
                                    </Grid>
                                    <Grid size="auto">
                                        <Button variant="contained" onClick={save}>
                                            {creatingNewRateGroup ? "Create" : "Save"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <ConfirmModal
                    {...deleteThresholdConfirmation}
                />
                <AddThresholdModal
                    {...addThresholdModal}
                />
            </Box>
        </React.Fragment >)
    );
}


function AddThresholdModal({ open, existing_thresholds, callback }) {
    const [threshold, setThreshold] = React.useState(2);
    const threshold_exists = existing_thresholds.findIndex((x) => x === threshold) !== -1
    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => callback(-1)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    Add Threshold
                    <IconButton
                        aria-label="close"
                        onClick={() => callback(-1)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="threshold"
                            label="Threshold"
                            type="number"
                            fullWidth
                            variant="standard"
                            value={threshold}
                            onChange={(event) => setThreshold(Math.max(parseInt(event.target.value), 1))}
                            error={threshold_exists}
                            helperText={threshold_exists ? `Threshold already exists` : ""}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                            <Button variant='outlined' color='error' onClick={() => callback(-1)} sx={{ mr: 1 }}>
                                <CancelIcon /> <Box sx={{ pl: 1 }}><span>Cancel</span></Box>
                            </Button>
                        </Grid>
                        <Grid size="auto">
                            <Button disabled={threshold_exists} variant="contained" autoFocus onClick={() => callback(threshold)}>
                                <CheckIcon /> <Box sx={{ pl: 1 }}><span>Confirm</span></Box>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}